import React, { useCallback } from "react";
import { format } from "date-fns";
import { withRouter, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import { withTheme } from "styles/styled_components";
import { IThemeInterface } from "styles/theme";

import Icon, { ICON_TYPE, ICON_COLOR } from "components/shared/icon";
import { trackEvent } from "helpers/analytics";
import RenderForFlag from "helpers/launch_darkly";
import { DateFormats } from "helpers/dates";

interface IEditDayLink extends RouteComponentProps {
  day: Date;
  theme: IThemeInterface;
}

function BaseDayEdit({ day, location, theme }: IEditDayLink) {
  const { pathname, search } = location;
  const dayViewParam = `dayView=${format(day, DateFormats.YEAR_MONTH_DAY)}`;
  const trackDayLink = useCallback(
    () => trackEvent("View the single day (from week view link)"),
    []
  );
  return (
    <RenderForFlag flag="workforceDayView">
      <Link
        onClick={trackDayLink}
        title={`Edit ${format(day, DateFormats.WEEKDAY_ORD)}`}
        to={`${pathname}${search}&${dayViewParam}`}
      >
        <Icon
          type={ICON_TYPE.EDIT}
          color={ICON_COLOR.BLUE}
          size={theme.iconSize.tiny}
        />
      </Link>
    </RenderForFlag>
  );
}

export default withRouter(withTheme(BaseDayEdit));
